// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"c27a5d4e","593":"1d7241b7"}[chunkId] + ".css";
};